// removed by extract-text-webpack-plugin
module.exports = {"HowItWorks":"TrdHowItWorks__-loca-___L5OW","Open":"TrdHowItWorks__-loca-__3ksp-","Close":"TrdHowItWorks__-loca-__3JgL4","SideDrawerCloseButton":"TrdHowItWorks__-loca-__1hGDF","BestWishes":"TrdHowItWorks__-loca-__F6Wed"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/HowItWorks/TrdHowItWorks/TrdHowItWorks.css
// module id = 121
// module chunks = 0